import { useEffect, useState } from 'react';

import type { Swiper as SwiperType } from 'swiper';

import { Typography } from '@ui/uikit/components/common/Typography';
import { ChevronLeft } from '@ui/uikit/components/icons/mono/ChevronLeft';
import { ChevronRight } from '@ui/uikit/components/icons/mono/ChevronRight';

import styles from './PreviewSwiperPagination.module.scss';

const PreviewSwiperPagination = ({ swiper }: { swiper: SwiperType | null }) => {
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(1);

  useEffect(() => {
    if (!swiper) {
      return;
    }

    setTotal(swiper?.slides?.length);
    setCurrent(swiper?.realIndex + 1);

    const update = () => setCurrent(swiper?.realIndex + 1);
    swiper.on('slideChange', update);

    return () => {
      swiper.off('slideChange', update);
    };
  }, [swiper]);

  return (
    <div className={styles['container']}>
      <button onClick={() => swiper?.slidePrev()}>
        <ChevronLeft color="primary" />
      </button>
      <Typography variant="caption-s" color="white">
        {current} / {total}
      </Typography>
      <button onClick={() => swiper?.slideNext()}>
        <ChevronRight />
      </button>
    </div>
  );
};

export { PreviewSwiperPagination };
